import { Point } from "highcharts";
import { money } from "@/utils/numeral/money";

export const getAccountsBarViewChartTooltipValueGetter = (point: Point) => {
  const x = point.x;
  const name = point.category || point.name || "N/A";

  let total = 0;

  return `
        <div style="font-weight: bold; margin-bottom: 12px;">${name}</div>
        
        ${point.series.chart.series
          .map((series) => {
            const data = series.data?.[x] as any;
            const cost = data?.point?.y;

            total = total + cost;

            return `<div style="display: flex; justify-content: space-between; align-items: center; gap:40px; margin-bottom: 8px;">
              <div  style="display: flex; align-items: center; ">
                <span style="display:inline-block; width:4px; height:16px; border-radius:2px; background:${data?.color}; margin-right:6px;"></span>
                ${series.name}
              </div>
              
              <span>
                ${money(cost)}
              </span>
            </div>`;
          })
          .join("")}
       
        
        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 12px; padding-top: 6px; font-weight: bold;">
          <span>Total Cost</span>  <span>${money(total)}</span>
        </div>
    `;
};
